import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Avatar, FlexBox, Icon, IconButton, Text, Timestamp, Tooltip, } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { conversationChannelAttributes } from 'lib-shared-legacy-types';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { UnbanUserModal, } from 'components/shared/unbanUserModal/unbanUserModal';
import rowStyles from '../bansRow.module.scss';
const DELAY_FETCH = 1000;
// Table column components
// -----------------------
const renderContact = ({ user }) => (_jsxs(FlexBox, Object.assign({ alignItems: "center" }, { children: [_jsx(Avatar, { className: rowStyles.userAvatar, user: user }), _jsxs("div", Object.assign({ className: rowStyles.userInfo }, { children: [_jsx("div", Object.assign({ className: rowStyles.userName }, { children: user.name })), user.email && _jsx("div", Object.assign({ className: rowStyles.userEmail }, { children: user.email }))] }))] })));
const renderBannedChannelsIcons = ({ bans, }) => (_jsx(FlexBox, Object.assign({ flexWrap: "wrap" }, { children: bans.map((ban) => {
        const { id, channel } = ban;
        const channelAttributes = conversationChannelAttributes.get(channel);
        const iconName = (channelAttributes === null || channelAttributes === void 0 ? void 0 : channelAttributes.icon) || 'question';
        const tooltipContent = (channelAttributes === null || channelAttributes === void 0 ? void 0 : channelAttributes.prettyName) || 'Unknown channel';
        return (_jsx(Tooltip, Object.assign({ content: tooltipContent, dark: true }, { children: _jsx(FlexBox, Object.assign({ className: classnames(rowStyles.channel, {
                    [rowStyles.banned]: true,
                }), alignItems: "center", justifyContent: "center" }, { children: _jsx(Icon, { name: iconName }) })) }), id));
    }) })));
const renderLastBan = ({ bans }) => {
    var _a, _b;
    return (_jsxs("div", Object.assign({ className: rowStyles.lastBanInfo }, { children: [((_a = bans[0]) === null || _a === void 0 ? void 0 : _a.banned_at) && (_jsx("div", Object.assign({ className: rowStyles.lastBanInfoDate }, { children: _jsx(Timestamp, { relative: true, time: bans[0].banned_at }) }))), ((_b = bans[0]) === null || _b === void 0 ? void 0 : _b.banning_agent) && (_jsxs("div", Object.assign({ hidden: true, className: rowStyles.lastBanInfoAgent }, { children: ["by ", bans[0].banning_agent.name] })))] })));
};
const renderUnbanButtonWithRefreshItems = (refreshItems) => function RenderUnbanButton({ bans, user, }) {
    const [isUnbanModalOpen, setIsUnbanModalOpen] = useState(false);
    // checking if there is a ban without an unban, to see if there are any active bans
    const hasActiveBan = !bans.reduce((acc, { unbanned_at }) => acc && !!unbanned_at, true);
    return (hasActiveBan && (_jsxs(_Fragment, { children: [_jsx(Tooltip, Object.assign({ content: "Unban", dark: true }, { children: _jsx(IconButton, { variant: "tertiary", icon: "undo", onClick: () => setIsUnbanModalOpen(true) }) })), _jsx(UnbanUserModal, { user: user, 
                // NOTE: for now we only ban on chat - we'll need to rethink this when we have bans on all channels
                channel: "widget_chat", isOpen: isUnbanModalOpen, onClose: (event) => {
                    setIsUnbanModalOpen(false);
                    if (!event.canceled && event.response) {
                        setTimeout(() => {
                            refreshItems();
                        }, DELAY_FETCH);
                    }
                } })] })));
};
// Sub-table column components
// ---------------------------
const renderChannel = ({ channel }) => {
    var _a;
    const channelIcon = (_a = conversationChannelAttributes.get(channel)) === null || _a === void 0 ? void 0 : _a.icon;
    return (channelIcon && (_jsx(Icon, { name: channelIcon, style: { verticalAlign: 'middle' } })));
};
const renderBannedBy = ({ banning_agent }) => (_jsx(Link, Object.assign({ to: `/contacts/user/${banning_agent.id}` }, { children: banning_agent.name })));
const renderBannedAt = ({ banned_at }) => (_jsx(Timestamp, { relative: true, time: banned_at }));
const renderConversation = ({ csid }) => (csid && _jsxs(Link, Object.assign({ to: `/conversation/${csid}` }, { children: ["#", csid] }))) || (_jsx(Text.Paragraph, Object.assign({ as: "span", subdued: true }, { children: "n/a" })));
// Columns
// -------
export const tableColumns = (refreshItems) => [
    {
        label: 'Contact',
        selector: renderContact,
    },
    {
        label: 'Banned on',
        style: { width: '45%' },
        selector: renderBannedChannelsIcons,
    },
    {
        label: 'Last ban',
        style: { width: '15%' },
        selector: renderLastBan,
    },
    {
        style: { width: 1 },
        selector: renderUnbanButtonWithRefreshItems(refreshItems),
    },
];
export const subTableColumns = [
    { style: { width: 1 }, selector: renderChannel },
    {
        label: 'Banned by',
        style: { width: '20%' },
        selector: renderBannedBy,
    },
    {
        label: 'Banned at',
        style: { width: '18%' },
        selector: renderBannedAt,
    },
    { label: 'Conversation', selector: renderConversation },
];
